import Commons from '../../../../Services/Common/Common';
import dayjs from 'dayjs';

export const M_FinalSign_BASIC_Schema = {
  mapper: {
    save1: {
      SessionCd: (row) => Commons.EncryptAES(row.sessionCd.toString() ?? '') || '',
      UserId: (_, context) => context.userInfo?.userid ?? '',
      CompleteYn: (row) => Commons.EncryptAES(row.completeYn ?? 'N') || '',
      SignImagePath: (row) => Commons.EncryptAES(row.signImagePath ?? '') || '',
      SignDate: (row) => Commons.EncryptAES(row.signDate ?? '') || '',
      IsSkipped: (row) => Commons.EncryptAES(row.isSkipped ?? 'N') || '',
      HostYn: (row) => Commons.EncryptAES(row.hostYn ?? 'N') || '',
      EntranceDt: (row) =>
        Commons.EncryptAES(row.entranceDt ?? dayjs().format('YYYY-MM-DD HH:mm:ss')) || '',
      ExitDt: (row) => Commons.EncryptAES(row.exitDt ?? '') || '',
      StayTime: (row) => Commons.EncryptAES(row.stayTime.toString() ?? '0') || '',
    },
  },
};
